module.exports = __webpack_public_path__ + "img/icon-errors.ab61678d.png";